import {
  ContentHeader,
  SearchContainer,
  HeaderContainer,
  CategoryContainer,
} from "./style";
import Logo from "../../assets/logo.svg";
import { useSelector } from "react-redux";
import { InputSearch } from "../InputSearch";
import Partner from "../../assets/partner.svg";
import Locate from "../../assets/location-on.svg";
import Cart from "../../assets/shopping-cart.svg";
import Expand from "../../assets/expand-more.svg";
import Account from "../../assets/account-circle.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";

export function Header() {
  const data = useSelector((state) => state.cartSlice.data);
  const navigate = useNavigate();
  const location = useLocation();

  const quantity = data.reduce((acc, product) => {
    return acc + product.quantity;
  }, 0);

  function redirectPage() {
    navigate("/products");
    if (location.pathname === "/successful-purchase") window.location.reload();
  }

  return (
    <HeaderContainer>
      <ContentHeader>
        <SearchContainer>
          <div>
            <img src={Logo} alt="Logo Happy Shop" onClick={redirectPage} />
            <InputSearch />
          </div>
          <div>
            <p>
              <img src={Locate} alt="icon gps" />
              Selecione o Endereço
            </p>
            <p>
              <img src={Account} alt="icon user" />
              Entrar
            </p>
            <p>
              <Link to="/product-cart" className="cartButton">
                {quantity > 0 && <span>{quantity}</span>}
                <img src={Cart} alt="icon cart" />
              </Link>
              Carrinho
            </p>
          </div>
        </SearchContainer>
        <CategoryContainer>
          <ul>
            <span>
              Categorias
              <button>
                <img src={Expand} alt="expand" />
              </button>
            </span>
            <li>Ofertas</li>
            <li>Produtos Internacionais</li>
            <li>Marketplace</li>
          </ul>
          <img src={Partner} alt="" className="partner" />
        </CategoryContainer>
      </ContentHeader>
    </HeaderContainer>
  );
}
